/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import Profile from '../Profile';
import datalakeAlpha from '../../assets/images/Menu/datalake_alpha.png';
import './styles.css';
import { http } from '../../services/httpService';

const HeaderBar = () => {
	const { isAuthenticated, loginWithRedirect, logout } = useAuth0();

	const navigate = useNavigate();

	const [profileDialog, setProfileDialog] = useState(false);

	const handleLogout = () => {
		http.defaults.headers.common.Authorization = `Bearer`;
		logout({ logoutParams: { returnTo: process.env.REACT_APP_URL } });
	};

	const menuItemsPublic = [
		{
			label: 'Dashboard',
			command: () => navigate('/Home'),
		},
		{
			label: 'About',
			command: () => navigate('/About'),
		},
		{
			label: 'Login',
			className: 'login-item',
			command: () => loginWithRedirect(),
		},
	];

	const menuItemsValidated = [
		{
			label: 'Dashboard',
			command: () => navigate('/Home'),
		},
		{
			label: 'About',
			command: () => navigate('/About'),
		},
		{
			label: 'Tools',
			items: [
				{
					label: 'Survey Data Cleaner',
					command: () => window.open(process.env.REACT_APP_SURVEY_CLEANER),
				},
				{
					label: 'Crop Model Data Transformer',
					command: () => window.open(process.env.REACT_APP_CROP_TRANSFORMER),
				},
			],
		},
		// {
		// 	label: 'My Datapools',
		// 	className: 'login-item',
		// 	command: () => {
		// 		setActiveIndex(2);
		// 		navigate('/Home');
		// 	},
		// },
		{
			label: 'My Data Files',
			className: 'login-item',
			command: () => navigate('/MyDataFiles'),
		},
		{
			label: 'My APIs',
			command: () => navigate('/MyApis'),
			// template: <Button className="my-apis" text label="My APIs" tooltip="Coming Soon" />,
			// disabled: true,
		},
		{
			icon: 'pi pi-user',
			className: 'logout-menu',
			items: [
				{
					label: 'Profile',
					icon: 'fa-solid fa-user',
					command: () => setProfileDialog(true),
				},
				{
					label: 'Logout',
					icon: 'fa-solid fa-right-from-bracket',
					command: handleLogout,
				},
			],
		},
	];

	const menuItems = useMemo(() => {
		if (isAuthenticated) {
			return menuItemsValidated;
		}
		return menuItemsPublic;
	}, []);

	const startTemplate = () => {
		return (
			<Button rounded text onClick={() => navigate('/Home')}>
				<img src={datalakeAlpha} alt="logo" style={{ height: '70px' }} />
			</Button>
		);
	};

	return (
		<div className="menu-bar">
			<Profile profileDialog={profileDialog} setProfileDialog={setProfileDialog} />
			<Menubar model={menuItems} start={startTemplate} style={{ width: '100%' }} />
		</div>
	);
};

export default HeaderBar;
